import { useEffect } from "react";
import { useFiltersContext } from "../../../../pages/Workspace/UserFilters/FiltersContext";
import { useWorkspaceStore } from "../../../../store/workspace/WorkspaceStore";
import { isOpportunityTypeFilterValid } from "../utils";
import { FILTERS_KEYS } from "../../../../pages/Workspace/UserFilters/constants";

/**
 * Hook to monitor and automatically clear invalid opportunity type filters
 * when workspace configuration changes (e.g., whitespace file deleted, hierarchy matching disabled)
 */
export const useOpportunityTypeFilterValidation = () => {
  const { clearInvalidAppliedFilter } = useFiltersContext();
  const userFilters = useWorkspaceStore((state) => state.userFilters);
  const workspaceWhitespace = useWorkspaceStore(
    (state) => state.draft?.configuration?.whitespace
  );

  useEffect(() => {
    // Create configuration object
    const config = {
      hasWhitespaceFile: Boolean(
        workspaceWhitespace?.fileId && workspaceWhitespace?.lastMatched
      ),
      enableHierarchyClassification: Boolean(
        workspaceWhitespace?.enableHierarchyClassification ?? false
      ),
      fileId: workspaceWhitespace?.fileId,
    };

    // Check if current applied filter is still valid
    if (userFilters?.opportunityType) {
      const isValid = isOpportunityTypeFilterValid(
        userFilters.opportunityType,
        config
      );

      if (!isValid) {
        // Clear the invalid filter immediately
        clearInvalidAppliedFilter(FILTERS_KEYS.opportunityType);
      }
    }
  }, [
    workspaceWhitespace?.fileId,
    workspaceWhitespace?.lastMatched,
    workspaceWhitespace?.enableHierarchyClassification,
    userFilters?.opportunityType,
    clearInvalidAppliedFilter,
  ]);
};
